/**
 * Guide Page
 *
 * Main guide list page with grid layout
 */

import { Container, Title, Text, Stack, SimpleGrid } from '@mantine/core';
import { Layout } from '../../shared/components';
import { useSEO } from '../../shared/hooks';
import { GuideCard } from './components/Guide';
import { GUIDE_ITEMS } from '../../data/guide/guideData';

/**
 * Guide Page Component
 *
 * Displays all guide items in a grid layout
 */
export function Guide() {
  useSEO({
    title: 'Przewodnik - Analizy taryfowe',
    description: 'Analizy kosztów energii i porównanie taryf. Sprawdź która taryfa jest najlepsza dla Twojego gospodarstwa domowego.',
  });

  return (
    <Layout isAuthenticated={false}>
      <Container size="lg" py={80}>
        <Stack gap="xl">
          {/* Header */}
          <div>
            <Title order={1} mb="md">
              Przewodnik
            </Title>
            <Text size="lg" c="dimmed">
              Analizy przedziałów kosztów energii - sprawdź która taryfa jest dla Ciebie najlepsza
            </Text>
          </div>

          {/* Guide Grid */}
          <SimpleGrid
            cols={{ base: 1, sm: 2, md: 3 }}
            spacing="lg"
          >
            {GUIDE_ITEMS.map((item) => (
              <GuideCard key={item.id} item={item} showCTA />
            ))}
          </SimpleGrid>
        </Stack>
      </Container>
    </Layout>
  );
}
